// extracted by mini-css-extract-plugin
export default {"add-permissions-btn":"styles_add-permissions-btn__CiJ7U"};